import React from 'react';
import { Box, Typography } from '@mui/material';

const Subcontractors: React.FC = () => {
  return (
    <Box p={3}>
      <Typography variant="h2">Subcontractors</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Placeholder page for managing subcontractors. Implement listing and CRUD.
      </Typography>
    </Box>
  );
};

export default Subcontractors;